import { useState, useEffect } from "react";
import NavbarHome from "../Navbar/NavbarHome";
import "react-datepicker/dist/react-datepicker.css";
import "../../scss/bill.scss";
import "../../scss/FoodBeverage.scss";
import "../../scss/filter.scss";
import axios from "axios";
import BillShowTable from "./Table/BillShowTable";
import ReactSidebar from "../ReactSidebar";
import Footer from "../Footer";
import Barchart from "./Table/Barchart";
import WeeklySalesChart from "../Charts/WeeklySalesChart";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import WeeklySalesByCompany from "../Charts/WeeklySalesByCompany";
import TodaysSalesByCompany from "../Charts/TodaysSalesByCompany";
import { ImSpinner8 } from "react-icons/im";
import { useUrls } from "../../context/UrlContext";
import OutletSearch from "../SelectSearch/OutletSearch";
import { useOutlet } from "../../context/OutletContext";
import { FiSearch } from 'react-icons/fi';

const Bill = () => {
  let url = process.env.REACT_APP_BASE_URL;
  const today = new Date().toLocaleDateString('en-CA')
  const userID = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const [selectedOutlet, setSelectedOutlet] = useState();

  const { banquetUrls } = useUrls();
  const { defaultOutlet } = useOutlet();

  const [viewMode, setViewMode] = useState(sessionStorage.getItem("billViewMode") || "overview");
  // const [viewMode, setViewMode] = useState(sessionStorage.getItem("billViewMode") || "details");

  useEffect(() => {
    sessionStorage.setItem("billViewMode", viewMode)
  }, [viewMode])

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState([]);
  const [isOrder, setIsOrder] = useState(true);
  const [food, setFood] = useState([]);
  const [beverage, setBeverage] = useState([]);
  const [beverageGroup, setBeverageGroup] = useState([]);
  const [foodGroup, setFoodGroup] = useState([]);
  const [FoodBeverageSum, setFoodBeverageSum] = useState([]);
  const [totalInfo, setTotalInfo] = useState({});
  const [show, setShow] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState({});
  const [dineinTabs, setDineinTabs] = useState({});
  const [splitDetails, setSplitDetails] = useState({});
  const [arrow, setArrow] = useState(false);
  const [billno, setBillno] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [discountData, setDiscountData] = useState();

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFile(null);
    setPreview(null);
  };

  const toggleArrow = () => {
    setArrow(!arrow);
  };

  const fetchSummaryReport = async () => {
    if (!token || !startDate || !endDate) return;

    try {
      const { data } = await axios.post(`${url}/summaryreport`, {
        outlet: selectedOutlet || defaultOutlet,
        dateStart: startDate,
        dateEnd: endDate,
        token,
        employee_id: Number(userID)
      });

      setSplitDetails(data.splitDetails);
      setDineinTabs(data);
      setPaymentStatus(data.paymentStats);

      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  useEffect(() => {
    if (!token) return;

    const loadData = async () => {
      await Promise.allSettled([
        fetchSalesHistory(),
        fetchSummaryReport(),
        fetchDiscountData(),
      ]);

      setShow(true);
    };

    loadData();
  }, [selectedOutlet, token]);

  const viewBill = async () => {
    setLoading(true);
    setIsOrder(true);

    try {
      await Promise.allSettled([
        fetchSalesHistory(),
        fetchSummaryReport(),
        fetchDiscountData(),
      ]);

      setBillno("");
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  const [startBillNum, setStartBillNumber] = useState("");
  const [endBillNum, setEndBillNumber] = useState("");

  useEffect(() => {
    if (!order?.length) {
      setStartBillNumber("");
      setEndBillNumber("");
      return;
    }

    const billNumbers = order
      .map(item => item.bill_no)
      .filter(bill => bill !== null && bill !== undefined && String(bill).trim() !== "")
      .map(Number)
      .filter(num => !isNaN(num));

    if (!billNumbers.length) {
      setStartBillNumber("");
      setEndBillNumber("");
      return;
    }

    setStartBillNumber(String(Math.min(...billNumbers)));
    setEndBillNumber(String(Math.max(...billNumbers)));
  }, [order]);

  const handleBillNumber = (e) => {
    setBillno(e.target.value);
    setIsOrder(false);
  };



  /* Normal */

  // const fetchSalesHistory = async () => {
  //   if (!selectedOutlet || !token || !startDate || !endDate) return;

  //   try {
  //     const { data } = await axios.post(`${url}/saleshistory`, {
  //       outlet: selectedOutlet,
  //       dateStart: startDate,
  //       dateEnd: endDate,
  //       token,
  //     });

  //     setTotalInfo(data);
  //     setOrder(data.orderDetails);
  //     setFood(data.itemDetails.food);
  //     setBeverage(data.itemDetails.beverage);
  //     setFoodBeverageSum(data.itemDetails.itemSum);
  //     setBeverageGroup(data.itemDetails.beverageGroup);
  //     setFoodGroup(data.itemDetails.foodGroup);
  //     setShow(true);

  //     return data;
  //   } catch (err) {
  //     console.log(err);
  //     throw err;
  //   }
  // };

  // useEffect(() => {
  //   if (!selectedOutlet || !token || !startDate || !endDate) return;

  //   if (billno === "") {
  //     axios
  //       .post(`${url}/saleshistory`, {
  //         outlet: `${selectedOutlet}`,
  //         dateStart: startDate,
  //         dateEnd: endDate,
  //         token: token,
  //       })
  //       .then((response) => {
  //         setIsOrder(true);
  //         setShow(true);
  //         setTotalInfo(response.data);
  //         setOrder(response.data.orderDetails);
  //         setFood(response.data.itemDetails.food);
  //         setBeverage(response.data.itemDetails.beverage);
  //         setFoodBeverageSum(response.data.itemDetails.itemSum);
  //         setBeverageGroup(response.data.itemDetails.beverageGroup);
  //         setFoodGroup(response.data.itemDetails.foodGroup);
  //       })
  //       .catch((error) => {
  //         console.log(error)
  //       });
  //   }
  //   if (billno) {
  //     axios
  //       .post(`${url}/billsearch`, {
  //         outlet: selectedOutlet,
  //         billno: billno,
  //         token: token,
  //       })
  //       .then((response) => {
  //         setIsOrder(false);
  //         setOrder(response.data);
  //         setShow(true);
  //       })
  //       .catch((error) => {
  //         // console.log(error)
  //       });
  //   }
  // }, [billno]);

  /* End */



  /* Complementary for alice, barc, hottopic */

  const isSameItem = (a, b) =>
    a.itemName?.trim() === b.itemName?.trim() &&
    a.Description?.trim() === b.Description?.trim();

  const mergeItems = (items, compItems) => {
    const merged = items.map((item) => {
      const match = compItems.find((comp) => isSameItem(item, comp));
      return {
        ...item,
        quantity: Number(item.quantity || 0),
        total: Number(item.total || 0),
        complementaryQuantity: match ? Number(match.quantity || 0) : 0,
        complementaryTotal: match ? Number(match.total || 0) : 0,
        hasComplementary: !!match,
        isComplementaryOnly: false,
      };
    });

    const compOnly = compItems
      .filter((comp) => !items.some((item) => isSameItem(item, comp)))
      .map((comp) => ({
        ...comp,
        quantity: 0,
        total: 0,
        complementaryQuantity: Number(comp.quantity || 0),
        complementaryTotal: Number(comp.total || 0),
        hasComplementary: true,
        isComplementaryOnly: true,
      }));

    return [...merged, ...compOnly];
  };

  const mergeGroups = (groups, compGroups) => {
    const merged = groups.map((group) => {
      const match = compGroups.find(
        (comp) => comp.groupName?.trim() === group.groupName?.trim()
      );
      return {
        ...group,
        groupTotal: Number(group.groupTotal || 0),
        qty: Number(group.qty || 0),
        complementaryGroupTotal: match ? Number(match.groupTotal || 0) : 0,
        complementaryGroupQty: match ? Number(match.qty || 0) : 0,
        hasComplementary: !!match,
        isComplementaryOnly: false,
      };
    });

    const compOnly = compGroups
      .filter(
        (comp) => !groups.some((g) => g.groupName?.trim() === comp.groupName?.trim())
      )
      .map((comp) => ({
        groupName: comp.groupName,
        groupTotal: 0,
        qty: 0,
        complementaryGroupTotal: Number(comp.groupTotal || 0),
        complementaryGroupQty: Number(comp.qty || 0),
        hasComplementary: true,
        isComplementaryOnly: true,
      }));

    return [...merged, ...compOnly];
  };

  const normalizeItemDetails = (itemDetails) => {
    const {
      food = [],
      beverage = [],
      foodGroup = [],
      beverageGroup = [],
      complementary_food = [],
      complementary_beverage = [],
      complementary_foodGroup = [],
      complementary_beverageGroup = [],
      itemSum = [],
      complementary_itemSum = [],
    } = itemDetails;

    const normalSum = itemSum[0] || {};
    const compSum = complementary_itemSum[0] || {};

    const mergedSum = {
      beveragequantity: Number(normalSum.beveragequantity || 0),
      beveragetotal: Number(normalSum.beveragetotal || 0),
      foodquantity: Number(normalSum.foodquantity || 0),
      foodtotal: Number(normalSum.foodtotal || 0),
      complementaryBeverageQuantity: Number(compSum.complementary_beverage_quantity || 0),
      complementaryBeverageTotal: Number(compSum.complementary_beverage_total || 0),
      complementaryFoodQuantity: Number(compSum.complementary_food_quantity || 0),
      complementaryFoodTotal: Number(compSum.complementary_food_total || 0),
      hasComplementary:
        Number(compSum.complementary_beverage_quantity || 0) > 0 ||
        Number(compSum.complementary_food_quantity || 0) > 0,
    };

    return {
      food: mergeItems(food, complementary_food),
      beverage: mergeItems(beverage, complementary_beverage),
      foodGroup: mergeGroups(foodGroup, complementary_foodGroup),
      beverageGroup: mergeGroups(beverageGroup, complementary_beverageGroup),
      itemSum: mergedSum,
    };
  };

  const fetchSalesHistory = async () => {
    if (!selectedOutlet || !token || !startDate || !endDate) return;

    setFood([]);
    setBeverage([]);
    setFoodGroup([]);
    setBeverageGroup([]);
    setFoodBeverageSum({});
    setOrder([]);
    setTotalInfo({});

    try {
      const { data } = await axios.post(`${url}/saleshistory`, {
        outlet: selectedOutlet,
        dateStart: startDate,
        dateEnd: endDate,
        token,
      });

      setTotalInfo(data);
      setOrder(data.orderDetails);

      const normalized = normalizeItemDetails(data.itemDetails);

      setFood(normalized.food);
      setBeverage(normalized.beverage);
      setFoodGroup(normalized.foodGroup);
      setBeverageGroup(normalized.beverageGroup);
      setFoodBeverageSum(normalized.itemSum);

      setShow(true);

      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const fetchDiscountData = async () => {
    setDiscountData({});

    try {
      const response = await axios.post(`${url}/salesitems-discount-totals`, {
        token,
        outlet: selectedOutlet || defaultOutlet,
        dateStart: startDate,
        dateEnd: endDate
      });
      const data = response.data;
      setDiscountData(data);
    } catch (error) {
      console.log("Discount fetch error : ", error);
    }
  }

  useEffect(() => {
    if (!selectedOutlet || !token || !startDate || !endDate) return;

    const fetchData = async () => {
      setFood([]);
      setBeverage([]);
      setFoodGroup([]);
      setBeverageGroup([]);
      setFoodBeverageSum({});
      setOrder([]);

      try {
        if (billno === "") {
          const response = await axios.post(`${url}/saleshistory`, {
            outlet: selectedOutlet,
            dateStart: startDate,
            dateEnd: endDate,
            token: token,
          });

          setIsOrder(true);
          setShow(true);
          setTotalInfo(response.data);
          setOrder(response.data.orderDetails);

          const normalized = normalizeItemDetails(response.data.itemDetails);

          setFood(normalized.food);
          setBeverage(normalized.beverage);
          setFoodGroup(normalized.foodGroup);
          setBeverageGroup(normalized.beverageGroup);
          setFoodBeverageSum(normalized.itemSum);
        }

        if (billno) {
          const response = await axios.post(`${url}/billsearch`, {
            outlet: selectedOutlet,
            billno: billno,
            token: token,
          });

          setIsOrder(false);
          setOrder(response.data);
          setShow(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [billno]);

  /* End */




  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadImage = async () => {
    if (!selectedFile) {
      toast.error('Please select a file first');
      return;
    }

    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append('logo', selectedFile);
      formData.append('token', token);
      formData.append('outlet', selectedOutlet);

      await axios.post(`${url}/upload_outlet_logo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success('Logo updated successfully');
      handleCloseModal();
    } catch (error) {
      toast.error('Error uploading logo');
      console.log("Logo upload error", error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <NavbarHome arrow={arrow} />

      <div className="flex-grow">
        <div className="px-8 w-full pt-4">
          <div className="flex rounded-md border bg-white w-full overflow-hidden">
            <button
              onClick={() => setViewMode("overview")}
              className={`flex-1 text-sm font-medium py-2 transition-colors ${viewMode === "overview"
                ? "bg-violet-900 text-white"
                : "bg-transparent text-gray-700 hover:bg-gray-100"
                }`}
            >
              Overview
            </button>
            <button
              onClick={() => setViewMode("details")}
              className={`flex-1 text-sm font-medium py-2 transition-colors ${viewMode === "details"
                ? "bg-violet-900 text-white"
                : "bg-transparent text-gray-700 hover:bg-gray-100"
                }`}
            >
              Details
            </button>
          </div>
        </div>

        {viewMode === "overview" ? (
          <>
            <div className="px-3 py-2.5 bg-white rounded shadow-md max-w-3xl mx-auto my-3">
              <div className="flex flex-wrap items-center justify-between">
                <label className="flex items-center gap-x-3 py-2 text-sm font-medium text-gray-700">
                  Start Date:
                  <input
                    type="date"
                    className="border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </label>

                <label className="flex items-center gap-x-3 py-2 text-sm font-medium text-gray-700">
                  End Date:
                  <input
                    type="date"
                    className="border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </label>

                <button
                  onClick={viewBill}
                  className="flex items-center gap-1 px-4 py-2 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm transition"
                >
                  {loading ?
                    <div className="flex justify-center items-center">
                      <ImSpinner8 className="animate-spin text-purple-300" />
                      <span className="ml-2">Loading...</span>
                    </div> : "View"}
                </button>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-between gap-4 px-4 pb-8 max-w-full">
              <WeeklySalesChart />

              {dineinTabs && <Barchart dineinTabs={dineinTabs} setSelectedOutlet={setSelectedOutlet} setViewMode={setViewMode} />}
            </div>

            {banquetUrls?.length > 0 && (
              <div className="flex flex-col lg:flex-row justify-between gap-4 px-4 pb-10 max-w-full">
                <div className="w-full lg:w-2/5">
                  <TodaysSalesByCompany banquetUrls={banquetUrls} />
                </div>

                <div className="w-full lg:w-3/5">
                  <WeeklySalesByCompany banquetUrls={banquetUrls} />
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="flex flex-col lg:flex-row relative py-8">
            <ReactSidebar
              dineinTabs={dineinTabs}
              paymentStatus={paymentStatus}
              splitDetails={splitDetails}
              toggleArrow={toggleArrow}
              arrow={arrow}
              startBillNum={startBillNum}
              endBillNum={endBillNum}
              FoodBeverageSum={FoodBeverageSum}
              outlet={selectedOutlet}
              order={order}
              startDate={startDate}
              endDate={endDate}
              url={url}
              token={token}
            />

            <div className="container main-content">
              <div className="flex justify-center gap-10 mb-6">
                {/* Chart */}
                <div className="w-[700px]">
                  <Barchart
                    dineinTabs={dineinTabs}
                    setSelectedOutlet={setSelectedOutlet}
                    setViewMode={setViewMode}
                  />
                </div>

                {/* Filters */}
                <div className="bg-white rounded-lg shadow-md p-4 flex flex-col gap-4">
                  {/* Outlet */}
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Outlet
                    </label>
                    <OutletSearch
                      selectedOutlet={selectedOutlet}
                      setSelectedOutlet={setSelectedOutlet}
                      token={token}
                    />
                  </div>

                  {/* Start Date */}
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Start Date
                    </label>
                    <input
                      type="date"
                      className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  {/* End Date */}
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      End Date
                    </label>
                    <input
                      type="date"
                      className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>

                  {/* Button */}
                  <button
                    onClick={viewBill}
                    className="w-full px-4 py-2 rounded-md font-medium text-sm bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md transition flex items-center justify-center gap-2"
                  >
                    <FiSearch className="w-4 h-4" />
                    View
                  </button>

                  <div className="flex gap-2 mt-auto justify-end">
                    <button
                      onClick={() => setShowModal(true)}
                      className="px-4 py-2 rounded-md font-medium bg-emerald-100 text-emerald-800 hover:bg-emerald-200 hover:shadow-md text-sm"
                    >
                      Upload Logo
                    </button>
                  </div>
                </div>

              </div>

              {show && (
                <BillShowTable
                  order={order}
                  isOrder={isOrder}
                  totalInfo={totalInfo}
                  selected={selectedOutlet}
                  token={token}
                  food={food}
                  foodGroup={foodGroup}
                  beverage={beverage}
                  beverageGroup={beverageGroup}
                  FoodBeverageSum={FoodBeverageSum}
                  startDate={startDate}
                  endDate={endDate}
                  url={url}
                  setBillno={setBillno}
                  handleBillNumber={handleBillNumber}
                  discountData={discountData}
                />
              )}
            </div>
          </div>
        )}

        <Modal show={showModal} onHide={handleCloseModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Upload Logo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <div>
                <label htmlFor="imageUpload" className="form-label">
                  Select Image
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="imageUpload"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <div>
                <label htmlFor="imageUpload" className="form-label">
                  Selected Outlet
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedOutlet}
                  disabled
                />
              </div>
            </div>

            {preview && (
              <div className="mt-3">
                <h6>Preview:</h6>
                <img
                  src={preview}
                  alt="Preview"
                  className="img-fluid mt-2"
                  style={{ maxHeight: '200px' }}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-secondary" onClick={handleCloseModal}>
              Close
            </button>
            <button
              className="btn btn-primary"
              onClick={handleUploadImage}
              disabled={!selectedFile || isUploading}
            >
              {isUploading ? 'Uploading...' : 'Upload'}
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      <Footer />
    </div>
  );
};

export default Bill;